
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/referral/[code]",
      function () {
        return require("private-next-pages/[market]/referral/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/referral/[code]"])
      });
    }
  